import React, { useEffect, useState } from "react";
import { ReactComponent as PlusIcon } from "../../../../assets/previewPage/icons/Plus.svg";
import { ReactComponent as MinusIcon } from "../../../../assets/previewPage/icons/minus.svg";

const FaqCard = ({ item, styles }) => {
  const [isOpen, setIsOpen] = useState(false);
  const coloum_value = JSON.parse(item?.coloum_value);

  const [fonts, setFonts] = useState(styles?.filter((item) => item.coloum_name === "fonts")?.[0]);
  const [fontValue, setFontValue] = useState(null);
  
  useEffect(() => {
    setFonts(styles?.filter((item) => item.coloum_name === "fonts")?.[0]);
  }, [item, styles])

  useEffect(() => {
    if(fonts?.coloum_value){
      setFontValue(JSON.parse(fonts?.coloum_value));
    }
  }, [fonts])

  return (
    <div
      className={`w-full bg-white rounded-lg select-none ${
        isOpen ? "py-[12px] px-[12px] " : "p-[12px]"
      }`}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer flex items-center justify-between select-none"
      >
        <div>
          <button style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-small3_b  capitalize text-heading_color font-${fontValue?.fontType?.value} break-words`}>
            {coloum_value?.[0]?.title}
          </button>
        </div>
        <div>
        {isOpen ? <MinusIcon className="w-[12px] h-[12px]"/> : <PlusIcon className="w-[12px] h-[12px] " />}
        </div>
      </div>
      {isOpen && (
        <div className="pt-[20px] ">
          <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-small3 text-body_copy_medium_color capitalize font-${fontValue?.fontType?.value} break-words`}>
          {coloum_value?.[0]?.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default FaqCard;
